import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { interval, Subscription } from 'rxjs';

@Component({
  selector: 'app-new-york-time',
  standalone: true,
  imports: [CommonModule],
  template: `
      <div class="time-display">
        <span class="hours">{{ formattedTime.hours }}</span>
        <span class="separator">:</span>
        <span class="minutes">{{ formattedTime.minutes }}</span>
        <span class="separator">:</span>
        <span class="seconds">{{ formattedTime.seconds }}</span>
      </div>
 
  `,
  styles: [`
  :host {
    display: flex;
  }
  
  .time-display {
    font-family: 'Bebas Neue', sans-serif;
    font-size: 58px;
    color: white;
  }
  
  .separator {
    font-size: 58px;
    padding-right: 0;
    letter-spacing: 0.05em;
  }

  .ampm {
    font-size: 0.5em;
    margin-left: 5px;
    vertical-align: super;
  }

  .date {
    font-size: 1.2em;
    opacity: 0.9;
  }
  `]
})
export class NewYorkTimeComponent implements OnInit, OnDestroy {
  private timeSubscription!: Subscription;
  
  formattedTime = {
    hours: '00',
    minutes: '00',
    seconds: '00',
    ampm: 'AM'
  };
  
  formattedDate = '';

  ngOnInit() {
    this.updateTime();
    
    // Обновляем время каждую секунду
    this.timeSubscription = interval(1000).subscribe(() => {
      this.updateTime();
    });
  }

  ngOnDestroy() {
    if (this.timeSubscription) {
      this.timeSubscription.unsubscribe();
    }
  }

  private updateTime() {
    const now = this.getNewYorkTime();
    
    this.formattedTime = {
      hours: this.formatTimeUnit(now.getHours() % 12 || 12),
      minutes: this.formatTimeUnit(now.getMinutes()),
      seconds: this.formatTimeUnit(now.getSeconds()),
      ampm: now.getHours() >= 12 ? 'PM' : 'AM'
    };
    
    this.formattedDate = now.toLocaleDateString('ru-RU', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      timeZone: 'America/New_York'
    });
  }

  private getNewYorkTime(): Date {
    return new Date(new Date().toLocaleString('en-US', {
      timeZone: 'America/New_York'
    }));
  }

  private formatTimeUnit(unit: number): string {
    return unit.toString().padStart(2, '0');
  }
}